import axios from '@/axios'

class MaintenanceNotificationProvider {
  async GetActiveMaintenanceNotification () {
    let result = await axios.get('maintenance/activeMaintenanceNotification')
    return result.data
  }
}

export default new MaintenanceNotificationProvider()



// WEBPACK FOOTER //
// ./src/providers/MaintenanceNotificationProvider.js